import Joi from 'joi';
import { actionCreator, objectSchemaOf } from '../helpers';

// action to be sent to ab-vision to stop recognition

export const RECOGNITION_STOP = 'VISION/RECOGNITION_STOP';

export interface IRecognitionStopAction {
  type: typeof RECOGNITION_STOP;
}

export const recognitionStopActionSchema = objectSchemaOf<
  IRecognitionStopAction
>({
  type: Joi.string().required().valid(RECOGNITION_STOP),
});

export const recognitionStop = actionCreator({
  type: RECOGNITION_STOP,
  schema: recognitionStopActionSchema,
});
